import React from 'react'

export function EstimatesIcon (props) {
  return (
    <svg viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M1 7.414v5.172c0 .89 1.077 1.337 1.707.707l2.586-2.586a1 1 0 000-1.414L2.707 6.707C2.077 6.077 1 6.523 1 7.414zM6 10c1.5-5.333 10.5-5.333 12 0-1.5 5.333-10.5 5.333-12 0z'
        stroke='currentColor'
        strokeWidth='2'
      />
      <circle cx='14' cy='10' r='1' fill='currentColor' />
      <path
        d='M22 0v21c0 1-1 2-2 2-1.5 0-3-1-3-2 0-1.5 1-1.5 1.5-2.5s0-2-1.5-2'
        stroke='currentColor'
        strokeWidth='2'
      />
      <circle cx='22' cy='14' r='2' fill='currentColor' />
    </svg>
  )
}
